import { appLocalStorage } from './storage';
import axios from 'axios'
import message from '../components/Brand/brandMessage'
import config from './config';
import { getLanguage, generateFToken, setLocalStorage } from './func';
const { compile } = require("path-to-regexp")

export default function request(options) {
  // A request owns its options; callers may reuse their specification.
  options = { ...options };
  let { data, url } = options

  try {
    let domain = ''
    const urlMatch = url.match(/[a-zA-z]+:\/\/[^/]*/)
    if (urlMatch) {
      ;[domain] = urlMatch
      url = url.slice(domain.length)
    }

    url = compile(url)(data);
    url = domain + url
  } catch (e) {
    message.error(e.message)
  }

  options.url = url
  options.timeout = options.timeout || 30000

  //добавляем в заголовки выбранный язык на фронте
  let headers = {
    [config.lng]: getLanguage()
  }

  //если в localStorage есть token, то добавляем его в заголовки
  if (appLocalStorage.getItem(config.token)) {
    headers[config.token]= appLocalStorage.getItem(config.token)
  }

  //если в localStorage есть ftoken, то добавляем его в заголовки. Если нет, то создаём, сохраняем в localStorage, добавляем в заголовки
  if (appLocalStorage.getItem(config.ftoken)) {
    headers[config.ftoken]= appLocalStorage.getItem(config.ftoken)
  } else {
    const ftoken = generateFToken();
    setLocalStorage(config.ftoken, ftoken);
    headers[config.ftoken]= ftoken
  }

  options.headers = headers;
  return axios(options)
    .then(response => {

      const { statusText, status, data } = response

      let result = {}
      if (typeof data === 'object') {
        result = data
        if (Array.isArray(data)) {
          result.list = data
        }
      } else {
        result.data = data
      }

      return Promise.resolve({
        success: true,
        message: statusText,
        statusCode: status,
        ...result,
      })
    })
    .catch(error => {
      const { response } = error

      if (error.code === 'ERR_CANCELED') {
        return {
          success: false,
          cancelled: true,
        }
      }

      let msg
      let statusCode

      if (response && response instanceof Object) {
        const { data, statusText } = response
        statusCode = response.status
        msg = data.message || statusText
      } else {
        statusCode = 600
        msg = error.message || 'Network Error'
      }

      return Promise.resolve({
        success: false,
        statusCode,
        message: msg,
        ...(typeof response?.data?.error?.code === 'string' ? { errorCode: response.data.error.code } : {}),
        ...(['normal', 'limited', 'quarantined', 'suspended'].includes(response?.data?.review?.state) ? {
          review: { state: response.data.review.state, draft_saved: response.data.review.draft_saved === true,
            ...(typeof response.data.review.draft_id === 'string' ? { draft_id: response.data.review.draft_id } : {}) },
        } : {}),
        ...(response?.headers?.['retry-after'] ? {
          retryAfter: Math.max(0, Number(response.headers['retry-after']) ||
            (Date.parse(response.headers['retry-after']) - Date.now()) / 1000 || 0),
        } : {}),
      })
    })
}
